import { ApiService } from './ApiService';
import apiResponse from './ApiResponse';

export class ChatStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async GetUser(userId: number) {
    try {
      const userIdString = userId.toString();
      const user = await this.api.get(`/chat/user/${encodeURIComponent(userIdString)}`);
      return apiResponse.Success(user);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async CreateChatToken(userId: number) {
    try {
      const userIdString = userId.toString();
      const token = await this.api.get(`/chat/session-token/${encodeURIComponent(userIdString)}`);
      return apiResponse.Success(token);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async PostAdminChatMessage(channel: string, message: string) {
    try {
      const response = await this.api.post('/chat', { channel, message });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async InviteUsersToChat(channel: string, userIds: string[]) {
    try {
      const response = await this.api.post('/chat/invite-members', { channel, userIds });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async RemoveUsersFromChat(channel: string, userIds: string[]) {
    try {
      const response = await this.api.post('/chat/remove-members', { channel, userIds });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
